import React from 'react';

import { Box, CircularProgress, Typography } from '@mui/material';

import { useUpdateExperienceValues } from '~/components/Experiences/hooks';
import useBrands from '~/components/Experiences/hooks/useBrands';

import { OfferBrandSchedule } from '~/services/ExperiencesService';

import OfferScheduleTable from './OfferScheduleTable';

export default function ExperienceCurationSchedules() {
  const { values } = useUpdateExperienceValues();
  const { data: allBrands, loading: brandsLoading } = useBrands();

  // brandSchedules comes from API when curationData=true
  // Cast to Array<OfferBrandSchedule> since the contract type includes it
  const brandSchedules = (values as { brandSchedules?: Array<OfferBrandSchedule> })?.brandSchedules ?? [];

  if (brandsLoading) {
    return (
      <Box display="flex" justifyContent="center" p={4}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" color="primary" gutterBottom>
        Offer Schedule
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Schedule information synced from the provider. RUN DATE is when the offer goes online, OFFLINE DATE is when it
        goes offline, and EXPIRY DATE is the travel deadline.
      </Typography>
      <OfferScheduleTable brandSchedules={brandSchedules} allBrands={allBrands} />
    </Box>
  );
}
